import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import BrandButton from 'components/BrandButton';
import LetterIcon from 'components/icons/LetterIcon.com.svg';
import { withTracker, hitTypes } from 'helpers/tracking';
import cn from './styles.local.less';

class SellerContactInfo extends PureComponent {
  static propTypes = {
    isRetail: PropTypes.bool.isRequired,
    emailContactUrl: PropTypes.string.isRequired,
    retailAdUrl: PropTypes.string.isRequired,
    trackAs: PropTypes.string.isRequired,
    tracker: PropTypes.object.isRequired,
  };

  handlePhoneClick = (e) => {
    e.stopPropagation();

    const { trackAs, tracker } = this.props;

    tracker.track(hitTypes.AD_CARD_PHONE_CTA_CLICK, {
      trackAs,
    });
  };

  handleEmailClick = (e) => {
    e.stopPropagation();

    const { trackAs, tracker } = this.props;

    tracker.track(hitTypes.AD_CARD_EMAIL_CTA_CLICK, {
      trackAs,
    });
  };

  render() {
    const { emailContactUrl, retailAdUrl, isRetail } = this.props;

    return (
      <div className={cn.root}>
        {isRetail ? (
          <BrandButton
            bsStyle="primary"
            className={cn.btn}
            href={retailAdUrl}
            target="_BLANK"
          >
            {__('carDetails.onlineBuyBtn')}
          </BrandButton>
        ) : (
          <BrandButton
            bsStyle="primary"
            className={cn.btn}
            href={emailContactUrl}
            onClick={this.handleEmailClick}
          >
            <LetterIcon className={cns(cn.emailIcon, 'hidden-xs')} />
            {__('carDetails.emailLabel')}
          </BrandButton>
        )}
      </div>
    );
  }
}

export default withTracker(SellerContactInfo);
